// .......................POST...................................
export const POST = (url, body, params, isBlob = false) => {
  return isBlob
    ? {
        method: "POST",
        params: params,
        body: body,
        url: url,
        responseHandler: async (res) => res.blob(),
      }
    : {
        method: "POST",
        params: params,
        body: body,
        url: url,
      };
};

// .......................PUT...................................
export const PUT = (url, body, params) => {
  return { method: "PUT", params: params, body: body, url: url };
};

// .......................GET...................................
export const GET = (url, params, isBlob = false) => {
  return isBlob
    ? { method: "GET", params: params, url: url, responseHandler: async (res) => res.blob() }
    : { method: "GET", params: params, url: url };
};

// .......................DELETE...................................
export const DELETE = (url, body, params) => {
  return { method: "DELETE", params: params, body: body, url: url };
};
